import { string } from "yup";

export const passwordSchema = () => string().min(4).max(16).required();

export const usernameSchema = () => string().min(2).max(25).required();
